import { render, staticRenderFns } from "./EmptyModalBase.vue?vue&type=template&id=48efaa6e&scoped=true&"
import script from "./EmptyModalBase.vue?vue&type=script&lang=js&"
export * from "./EmptyModalBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efaa6e",
  null
  
)

export default component.exports